import { Component, OnInit } from '@angular/core';
import { DashboardDossierRecouvrementService } from '../../core/service/suiviPortefeuille/dashboard-dossier-recouvrement.service';
import { first } from "rxjs/operators";
import { ChartViewDTO } from '../../core/model/chart_view/chart-view-dto';
import * as Highcharts from "highcharts";
import { QuantiteDossierRecouvrementSuiviPortefeuilleDTO } from '../../core/model/QuantiteDossierRecouvrementSuiviPortefeuilleDTO';
import { QuantiteDossierParMarcheEntrePeriodeDTO } from '../../core/model/QuantiteDossierParMarcheEntrePeriodeDTO';
import { DashboardPortefeuilleRisqueService } from '../../core/service/suiviPortefeuille/dashboard-portefeuille-risque.service';
import { QuantiteDossierRecouvrementDTO } from '../../core/model/QuantiteDossierRecouvrementDTO';

@Component({
  selector: "app-dossier-recouvrement",
  templateUrl: "./dossier-recouvrement.component.html",
  styleUrls: ["./dossier-recouvrement.component.scss"]
})
export class DossierRecouvrementComponent implements OnInit {
  highcharts = Highcharts;

  nombreByPeriode: ChartViewDTO;
  chartOptionsSuiviByPeriode: any;

  quantiteByPeriode: ChartViewDTO;
  chartOptionsQuantiteByPeriode: any;

  quantiteDossierRecouvrementSuiviPortefeuilleDTO: QuantiteDossierRecouvrementSuiviPortefeuilleDTO = new QuantiteDossierRecouvrementSuiviPortefeuilleDTO();
  quantiteDossierRecouvrementDTO: QuantiteDossierRecouvrementDTO[];

  constructor(
    private _dashboardDossierRecouvrementService: DashboardDossierRecouvrementService,
    private _dashboardPortefeuilleRisqueService: DashboardPortefeuilleRisqueService
  ) {}

  ngOnInit() {
    this.quantiteDossierPortefeuilleRisque();
    this.quantitehistoriqueRecouvrement();
  }

  quantiteDossierPortefeuilleRisque() {
    this._dashboardDossierRecouvrementService
      .quantiteDossierSuiviPortefeuilleRisque()
      .pipe(first())
      .subscribe(
        data => {
          this.quantiteDossierRecouvrementSuiviPortefeuilleDTO = data;
        },
        error => {
          console.log(error);
        }
      );
  }

  quantitehistoriqueRecouvrement() {
    this._dashboardDossierRecouvrementService
      .quantiteHistoriqueRecouvrement()
      .pipe(first())
      .subscribe(
        response => {
          this.quantiteDossierRecouvrementDTO = response;
        },
        error => {
          console.log(error);
        }
      );
  }


}
